module.exports = __webpack_public_path__ + "img/imge2.b3fdd944.webp";